import { ReactElement } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/Tooltip";

/**
 * A row action's tooltip. The child is the icon button or link itself (it
 * carries the same text as its aria-label).
 */
export default function IconTip({
  label,
  children,
}: {
  label: string;
  children: ReactElement;
}) {
  return (
    <Tooltip>
      <TooltipTrigger>{children}</TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
